export const messages = {
  en: {
    maintainancePlanMachine: {
      title: 'Maintenance Equipment',
      back: 'Back',
      add: 'Add',
      machineName: 'Equipment Name',
      machineId: 'Equipment ID',
      operation: 'Operation',
      delete: 'Delete',
      fetchError: 'Failed to fetch equipment list'
    },
    chooseMaintainancePlanMachine: {
      title: 'Select Equipment',
      machineNamePlaceholder: 'Enter equipment name',
      search: 'Search',
      reset: 'Reset',
      machineId: 'ID',
      machineName: 'Equipment Name',
      cancel: 'Cancel',
      submit: 'Submit',
      selectWarning: 'Please select at least one equipment',
      addSuccess: 'Added successfully',
      addError: 'Failed to add equipment',
      fetchError: 'Failed to fetch equipment list',
      locationDetail: 'Equipment locationDetail',
    },
    deleteMaintainancePlanMachine: {
      title: 'Confirm Operation',
      confirmText: 'Are you sure to delete this maintenance equipment?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deleteSuccess: 'Deleted successfully',
      deleteError: 'Failed to delete equipment'
    }
  },
  zh: {
    maintainancePlanMachine: {
      title: '保养设备',
      back: '返回',
      add: '添加',
      machineName: '设备名称',
      machineId: '设备编号',
      operation: '操作',
      delete: '删除',
      fetchError: '获取设备列表失败'
    },
    chooseMaintainancePlanMachine: {
      title: '选择设备',
      machineNamePlaceholder: '输入设备名称',
      search: '查询',
      reset: '重置',
      machineId: '编号',
      machineName: '设备名称',
      cancel: '取消',
      submit: '提交',
      selectWarning: '请至少选择一台设备',
      addSuccess: '添加成功',
      addError: '添加设备失败',
      fetchError: '获取设备列表失败',
      locationDetail: '设备位置',
    },
    deleteMaintainancePlanMachine: {
      title: '请确认您的操作',
      confirmText: '确定删除保养设备?',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功',
      deleteError: '删除设备失败'
    }
  }
}